const captions = {
  actionMenuItems: {
    availableActions: 'Available Form-flows',
    selectedActions: 'Restricted Form-flows',
    newSession: 'Run in new session',
    inDialog: 'Show in dialog',
    maximized: 'Show maximized',
    defaultMaintainFormFlow: 'Default Maintain Form-flow',
    inheritDefaultMaintainFormFlow: 'Default Maintain Form-flow (inherited from entity)',
    hideFromMenu: 'Hide from menu',
    maintainFormFlowDialog: {
      label: 'Maintain Form-flow Configurations',
      validationMessage: 'Note: Default Maintain Form-flow may not work if Form-flow Restrictions are in place, without the selected Form-flow.',
      selectFormFlowInfo: 'Please select a Form-flow from the list below to configure a control level Form-flow Restriction.',
      actionMenuVisibilityInfo: 'This will affect the visibility of Action Menu Items.',
      additionalInfo: 'Note: current Action Menu Items may be subject to Module or Business Rules Form-flow Restrictions.',
      restrictedFormFlowSubCaption: '(List of Form-flows that will be visible in the Action Menu Items)',
      availableFormFlowSubCaption: '(Form-flows in this list will not be visible in the Action Menu Items, unless added to the list above)'
    },
    newFormFlowConfiguration: {
      label: 'New Form-flow Configurations'
    }
  },
  addressField: {
    enterManually: 'Enter manually',
    noAddressSelected: 'No address selected'
  },
  autoRefresh: {
    autoRefresh: 'Auto refresh',
    never: 'Never',
    oneMinute: '1 Minute',
    fiveMinutes: '5 Minutes',
    tenMinutes: '10 Minutes',
    fifteenMinutes: '15 Minutes',
    thirtyMinutes: '30 Minutes',
    fortyFiveMinutes: '45 Minutes',
    oneHour: '1 Hour',
    twoHours: '2 Hours',
    threeHours: '3 Hours',
    fourHours: '4 Hours'
  },
  changePassword: {
    cancel: 'Cancel',
    changePassword: 'Change Password',
    confirmPassword: 'Confirm Password',
    newPassword: 'New Password',
    oldPassword: 'Old Password',
    passwordsAreNotIdentical: 'Passwords are not identical',
    passwordChangedSuccess: 'Password changed successfully! Use your new password the next time you log in.',
    passwordRequired: 'Password is required'
  },
  controlTower: {
    defaultLayoutTitle: 'Control Tower Default Layout',
    widgetName: 'Widget name',
    widgetX: 'X',
    widgetY: 'Y',
    widgetVariant: 'Variant',
    widgetCount: '{0} layout(s), {1} widget(s)',
    addWidget: 'Add widget',
    addLayout: 'Add layout',
    removeLayout: 'Remove layout',
    layout: 'Layout {0}',
    layoutDetails: 'Layout details',
    layoutConfiguration: 'Layout configuration',
    layoutName: 'Layout name',
    emptyLayout: 'The default layout for this control tower is empty. Users will still be able to use the Control Tower as normal but there will be no widgets displayed on first load (not recommended).'
  },
  conversation: {
    follow: 'Follow',
    followers: 'Followers',
    placeholder: 'Write your message here...',
    send: 'Send',
    following: 'Following',
    addFollowers: 'Add followers',
    searchPotentialFollowers: 'Search for {0}',
    dialog: {
      cancel: 'Cancel',
      close: 'Close',
      removeFollower: {
        areYourSure: 'Are you sure you want to remove follower {0}?',
        no: 'No',
        title: 'Remove follower',
        yes: 'Yes'
      },
      unsentMessage: {
        cancel: 'Cancel',
        discard: 'Discard',
        haveUnsentMessage: 'You have an unsent message.',
        send: 'Send',
        title: 'Unsent message'
      },
      addFollowersFailure: {
        title: 'Error adding followers',
        message: 'An error occurred while adding followers. We were unable to add the {0} followers.'
      }
    }
  },
  colorScheme: {
    addRule: 'Add Rule',
    colorSchemeName: 'Color Scheme Name',
    colorSchemeTitle: 'Color Scheme',
    colorSchemesTitle: 'Color Schemes',
    createNewColorScheme: 'Create New Scheme',
    manageColorSchemes: 'Manage Color Schemes',
    userDefinedColorSchemes: 'User Defined',
    systemDefinedColorSchemes: 'System Defined',
    standardColorScheme: 'Standard',
    delete: 'Delete',
    edit: 'Edit',
    ok: 'OK',
    loadSaved: 'Load Saved',
    header: 'Header',
    ruleBackgroundColor: 'Background Color',
    ruleTextColor: 'Text Color',
    ruleFilter: 'Filter',
    ruleName: 'Name',
    cancel: 'Cancel',
    noAvailableColorSchemes: 'There are no available color schemes',
    published: 'Published',
    schemeDetails: 'Scheme Details',
    rules: 'Rules',
    confirmDeleteTitle: 'Delete Color Scheme',
    confirmDeleteCaption: 'This color scheme will be removed from the system. Are you sure you want to delete {0}?'
  },
  dateField: {
    ariaLabelPrompter: 'Select Date',
    today: 'Today'
  },
  dateOffset: {
    atLeast: 'At least',
    atMost: 'At most'
  },
  dateTimeField: {
    ariaLabelPrompter: 'Select Date',
    now: 'Now',
    setDate: 'Set Date',
    setTime: 'Set Time',
    today: 'Today'
  },
  dialog: {
    acknowledge: 'Click to acknowledge that you have read and understood this warning.',
    apply: 'Apply',
    cancel: 'Cancel',
    clear: 'Clear',
    ok: 'OK',
    publish: 'Publish for all users',
    reset: 'Reset',
    save: 'Save',
    yes: 'Yes',
    no: 'No',
    close: 'Close',
    applyChanges: 'Apply changes'
  },
  gridActions: {
    Export: 'Export to Excel',
    Import: 'Import'
  },
  gridRowActions: {
    label: 'Disable Row Actions',
    Activation: 'Activation',
    Documents: 'Documents',
    eDocs: 'eDocs',
    Logs: 'Logs',
    Messages: 'Messages',
    Notes: 'Notes',
    Remove: 'Remove',
    Tracking: 'Tracking',
    Workflow: 'Workflow'
  },
  impersonate: {
    impersonate: 'Impersonate',
    impersonateUser: 'Impersonate User',
    searchUsers: 'Search for User',
    errorMessage: 'An error occurred while impersonate. We were unable to impersonate the user.'
  },
  search: {
    multipleChip: 'Multiple',
    noResults: 'No matches found',
    placeholder: 'Search',
    results: 'Top Results',
    suggestedFilters: 'Suggested Filters',
    searchableFields: 'Searchable Fields',
    restrictSearch: 'Restrict the search to',
    matchedOn: 'Matched on',
    open: 'Open',
    close: 'Close',
    jump: 'Jump To',
    add: 'Add'
  },
  searchDataTable: {
    edit: 'Edit',
    new: 'New',
    deleteRow: 'Delete Row',
    dragMoving: 'Moving 1 item',
    dragMovingMultiple: 'Moving {0} items',
    dragMoved: 'Moved 1 item',
    dragMovedMultiple: 'Moved {0} items',
    noItemsFound: 'No items found',
    search: 'Search',
    selected: '{0} selected'
  },
  searchList: {
    addRow: 'Add row',
    availableHeaders: 'Available columns',
    configureHeaders: 'Configure columns',
    cancel: 'Cancel',
    closeGroup: 'Close Group',
    count: 'Count: {0}',
    delete: 'Delete',
    empty: '(empty)',
    enableHeaderSizing: 'Enable column sizing',
    firstUse: {
      header: 'No records to show',
      bodycopy: 'Add a row to start populating the table'
    },
    groupBy: 'Group by column',
    headers: 'Columns',
    hideAggregateAria: 'Hide aggregations',
    item: '1 item',
    itemActions: 'Item Actions',
    items: '{0} items',
    lock: 'Lock',
    new: 'New',
    noData: {
      header: 'No results found',
      bodycopy: 'Try adjusting your filters to find more results',
      buttonLabel: 'Search'
    },
    noItemsFound: 'No items found',
    openGroup: 'Open Group',
    refresh: 'Refresh',
    save: 'Save',
    search: 'Search',
    selectedHeaders: 'Selected columns',
    settings: 'Settings',
    showAggregateAria: 'Show aggregations',
    sort: 'Sort',
    stopGrouping: 'Stop Grouping',
    toggleFilterAria: 'Filter by column',
    toggleSort: 'Sort by column',
    unlock: 'Unlock',
    wrap: 'Wrap'
  },
  filters: {
    add: 'Add',
    addGroup: 'Add Group',
    and: 'And',
    all: 'All',
    categoryBoolean: 'Flags',
    categoryCollection: 'Related Records',
    categoryDate: 'Dates',
    categoryGeo: 'Geo Locations',
    categoryNumber: 'Numbers',
    categoryOther: 'Other',
    categoryText: 'Text Search',
    contains: 'contains',
    endsWith: 'ends with',
    fieldSelectAriaLabel: 'Field',
    filter: 'Filter',
    filters: 'Filters',
    filtersTitle: 'Filters',
    from: 'From',
    greaterThan: 'greater than',
    greaterThanOrEqual: 'greater than or equal to',
    group: 'Group',
    hasDate: 'has date',
    hasDuration: 'has duration',
    hasNoDate: 'has no date',
    hasNoDuration: 'has no duration',
    header: 'Header',
    invalidField: 'Field does not exist',
    invalidFieldShort: 'Field missing',
    is: 'is',
    isBetween: 'is between',
    isBetweenOrEqual: 'is between or equal to',
    isBlank: 'is blank',
    isInTheDateRange: 'is in the date range',
    isInTheDateRangeValuePrefix: 'from',
    isInTheDateRangeValue2Prefix: 'to',
    isInThePast: 'is in the past',
    isInTheFuture: 'is in the future',
    isNot: 'is not',
    isNotBetween: 'is not between',
    isNotBetweenOrEqual: 'is not between or equal to',
    isNotBlank: 'is not blank',
    isNotSpecified: 'is not specified',
    isSpecified: 'is specified',
    lessThan: 'less than',
    lessThanOrEqual: 'less than or equal to',
    maxValue: 'maximum value',
    minValue: 'minimum value',
    more: 'more',
    no: 'No',
    notContain: 'not contain',
    notEnding: 'not ending',
    noFiltersApplied: 'No filters applied',
    notStarting: 'not starting',
    numberOfFiltersApplied: '{0} filters applied',
    oneFilterApplied: '1 filter applied',
    operationSelectAriaLabel: 'Operation',
    or: 'Or',
    selectFilter: '--- Select filter ---',
    startsWith: 'starts with',
    to: 'To',
    isEarlierThan: 'is earlier than',
    isLaterThan: 'is later than',
    value: 'Value',
    yes: 'Yes',
    filterName: 'Filter Name',
    loadSaved: 'Load Saved',
    delete: 'Delete',
    stopIfTrue: 'Stop If True',
    doesNotExist: 'does not exist',
    exists: 'exists',
    showAlertsOnly: 'Show Alerts Only',
    showAll: 'Show All',
    toggleQuickFilter: 'There are errors in the table. Click on the button to toggle filtering of records with errors.',
    valueSelectAriaLabel: 'Value',
    value1SelectAriaLabel: 'First value',
    value2SelectAriaLabel: 'Second value'
  },
  headers: {
    categoryBoolean: 'Flags',
    categoryDate: 'Dates',
    categoryNumber: 'Numeric',
    categoryText: 'Text',
    addresses: 'Addresses',
    measurement: 'Measurement',
    categoryGeo: 'Geo Locations',
    categoryCollection: 'Related Records'
  },
  imagePicker: {
    acceptButton: 'Ok',
    fileErrorHeader: 'Invalid file',
    invalidFileError: 'The file you chose does not appear to be a valid image file. Please ensure you are choosing a PNG, Bitmap or JPEG image.',
    maxFileSizeError: 'The file that you have chosen is too large and could cause performance issues if used in your application. Please choose a smaller file.'
  },
  jobAddress: {
    address2FieldLabel: 'Address line 2',
    addressFieldLabel: 'Address line 1',
    additionalInfoLabel: 'Additional information',
    cityFieldLabel: 'City',
    companyNameLabel: 'Organization name',
    contactFieldLabel: 'Fullname',
    contactPlaceholder: 'Search for contact',
    contactTab: 'Contact',
    countryFieldLabel: 'Country',
    edit: 'Edit',
    edited: 'Edited',
    emailFieldLabel: 'Email',
    errorState: 'There is error in the job address',
    mapLabel: 'Map location',
    mobileFieldLabel: 'Phone 2',
    phoneFieldLabel: 'Phone 1',
    noAddress: 'No address supplied.',
    noContactDetails: 'No contact details supplied.',
    postcodeFieldLabel: 'Postal/Zip code',
    stateFieldLabel: 'State/Province/Region',
    streetAltFieldLabel: 'Street (alt)',
    streetFieldLabel: 'Street'
  },
  lookup: {
    noResults: 'No records found',
    showing: 'Showing 1 to {0} of {1} results',
    showMore: 'Show More'
  },
  menu: {
    more: 'More'
  },
  passwordField: {
    capsLockMessage: 'Caps Lock is on'
  },
  textField: {
    ariaLabelPrompter: 'Prompt'
  },
  timeField: {
    ariaLabelPrompter: 'Select Time',
    now: 'Now'
  },
  schedule: {
    actionsHeader: 'Actions',
    activeHeader: 'Active',
    addBreak: 'Add Break',
    breaksHeader: 'Breaks',
    breaksOverlap: 'Breaks Overlap',
    copyDay: 'Copy',
    dayHeader: 'Day',
    hours: 'Hours',
    invalidEndTime: 'Invalid End Time',
    invalidStartTime: 'Invalid Start Time',
    minutes: 'Minutes',
    pasteDay: 'Paste',
    removeBreak: 'Remove Break',
    timeHeader: 'Time',
    totalHeader: 'Total'
  },
  searchBox: {
    noResults: 'No items found',
    showing: 'Showing 1 to {0} of {1} items',
    showMore: 'Show More'
  },
  searchControl: {
    ariaLabelPrompter: 'Advanced search dialog',
    noResults: 'No items found',
    notAvailable: 'NOT AVAILABLE',
    showing: 'Showing 1 to {0} of {1} items',
    showMore: 'Show More'
  },
  weekDay: {
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    sunday: 'Sunday'
  },
  edoc: {
    actions: 'Actions',
    dateAdded: 'Date Added',
    docTypeCode: 'Doc Type Code',
    description: 'Description',
    fileName: 'File Name',
    fileType: 'File Type',
    systemGenerated: 'System Generated',
    published: 'Published',
    deleted: 'Deleted',
    lastEditedBy: 'Last Edited By'
  },
  fileAttachment: {
    add: 'Add',
    clearAll: 'Clear All',
    clearUnsaved: 'Clear Unsaved',
    dropFile: 'Drop your file here or use the Add button',
    dropFiles: 'Drop your files here or use the Add button',
    noFiles: 'No Files'
  },
  formflowConfiguration: {
    label: 'Form-flow Configurations',
    availableFormFlows: 'Available Form-flows',
    selectedFormFlows: 'Selected Form-flow'
  },
  layouts: {
    confirmDelete: 'Are you sure you want to delete {0}?',
    confirmDeletePublic: `Warning: This is a published filter that is available to all users. 
        Are you sure you want to delete {0}?'`,
    confirmDeleteTitle: 'Delete Filter',
    confirmOverride: '{0} already exists. Are you sure you want to replace the existing filter?',
    confirmOverrideTitle: 'Warning - Replace Filter',
    editLayout: 'Edit Filter',
    includeFilter: 'Include Filter',
    includeHeaders: 'Include Headers',
    includeColorScheme: 'Include Color Scheme',
    includeDense: 'Include Dense',
    dense: 'Dense',
    layoutName: 'Filter Name',
    layouts: 'Filters',
    layoutsMenuAria: 'More actions',
    manageLayouts: 'Manage Filters',
    noAvailableLayouts: 'There are no available filters',
    resetLayout: 'Reset Current',
    saveLayout: 'Save Current',
    viewLayouts: 'Manage Filters'
  },
  themeConfiguration: {
    cancel: 'Cancel',
    close: 'Close',
    color: 'Color',
    colors: 'Colors',
    copyThemeFrom: 'Copy Theme From',
    custom: 'Custom',
    dark: 'Dark',
    portal: 'Portal',
    primary: 'Primary',
    brand: 'Brand',
    zebraStripes: 'DataTable Zebra Stripes',
    lightTheme: 'Light theme',
    darkTheme: 'Dark theme',
    logo: 'Logo',
    logoColor: 'Logo Background',
    logoDarkDescription: 'Dark Logo',
    logoLightDescription: 'Light Logo',
    logos: 'Logos',
    brandLogin: 'Login logo background',
    reset: 'Reset',
    save: 'Save',
    title: 'Theme Configuration',
    yes: 'Yes',
    no: 'No',
    presets: 'Themes',
    themeColors: 'Theme Colors',
    unset: 'Unset',
    fileSizeTooLarge: 'File Size Too Large',
    themeName: 'Theme name',
    systemThemeName: 'CargoWise default theme',
    newTheme: 'New theme',
    editTheme: 'Edit theme',
    configureBy: 'Configure by',
    hostname: 'Hostname',
    organisation: 'Organization',
    company: 'Company',
    branch: 'Branch',
    department: 'Department',
    configureTheme: 'Configure theme',
    createNewTheme: 'Create new theme',
    saveTheme: 'Save theme',
    system: 'System',
    userContact: 'User - Contact',
    userStaff: 'User - Staff',
    textColor: 'Text color',
    whiteText: 'White',
    blackText: 'Black',
    upload: 'Upload',
    navigation: 'Navigation'
  }
};

export { captions as default };
